<a class="banner__link" [href]="ban.p.url | gotoUrl" target="_blank" (click)="clk($event)">
    <picture class="banner__logo" *ngIf="ban.p.img" [xSrc]="ban.p.img[0]" [xSrcset]="{'*': 'w=112,f=sd'}"></picture>
    <div class="banner__body">
        <span dir="auto" class="wrd-ell" [innerHTML]="ban.p.name"></span>
    </div>
    <div class="banner__marking">{{ban.p.marking}}</div>
</a>
